import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditAgency from "../../components/agencies/FormAddEditAgency";

const CreateAgency = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/agencies");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditAgency
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateAgency;
